<template>
  <div class="">
    <div class="FleetFilter pb-5">
      <div class="row">
        <div class="col-12 col-md-3">
          <h3>Tank lining</h3>
          <div class="dropdown" :class="{'show': showLiningsDropdown}">
            <a href="#" class="btn btn-secondary btn-block dropdown-toggle" data-toggle="dropdown"
               @click.prevent="showLiningsDropdown = !showLiningsDropdown">
              {{ linings ? linings : "Choose" }}
            </a>
            <div class="dropdown-menu button-group">
              <a href="#" class="dropdown-item is-checked" @click.prevent="linings = null">
                All
              </a>
              <a href="#" class="dropdown-item" v-for="lining in tankLinings" @click.prevent="linings = lining">
                {{ lining }}
              </a>
            </div>
          </div>

        </div>
        <div class="col-12 col-md-3">
          <h3>Year built</h3>
          <div class="dropdown" :class="{'show': showLiningsDropdown}">
            <a href="#" class="btn btn-secondary btn-block dropdown-toggle" data-toggle="dropdown"
               @click.prevent="showLiningsDropdown = !showLiningsDropdown">
              {{ decade ? `${decade} - ${decade + 9}` : "Choose" }}
            </a>
            <div class="dropdown-menu button-group">
              <a href="#" class="dropdown-item is-checked" @click.prevent="decade = null">
                All
              </a>
              <a href="#" class="dropdown-item" v-for="s in shipDecades" @click.prevent="decade = s">
                {{ s ? `${s} - ${s + 9}` : "Choose" }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="totalCount">
      <template v-for="(ships, name) in filteredFleet">
        <div class="row" v-if="ships.length > 0">
          <div class="col-12">
            <h2>{{ name }}</h2>
          </div>
        </div>
        <div class="row grid show">
          <div class="col-6 col-md-4 grid-item" v-for="ship in ships" :key="ship.id">
            <a :href="ship.url">
              <img :src="ship.image" :alt="ship.name">
            </a>
            <div class="caption">
              <h3>
                {{ ship.name }}
              </h3>
              <p>
                <label>Year built</label>
                <span>{{ ship.year }}</span></p>
              <p>
                <label>Class</label>
                <span>{{ name }}</span></p>
              <p>
                <label>No. tanks</label>
                <span>{{ ship.tankCount }}</span></p>
              <p><a :href="ship.url" class="btn btn-secondary">More Details</a>
                <a :href="ship.pdf" target="_blank" class="btn btn-secondary"><i class="fas fa-download" aria-hidden="true"></i>
                  DOWNLOAD PDF</a>
              </p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <h3>No ships found which match all the criteria</h3>
    </template>
  </div>

</template>

<script>
export default {
  props: {
    fleet: Object
  },
  data: () => ({
    linings: null,
    decade: null,
    showLiningsDropdown: false,
  }),
  computed: {
    filteredFleet() {
      return Object.entries(this.fleet).map(([key, list]) => {
        let filteredList = list

        if (this.linings) {
          filteredList = filteredList.filter(ship => ship.tanklinings.includes(this.linings))
        }

        if (this.decade) {
          filteredList = filteredList.filter(ship => ship.decade == this.decade)
        }

        return [key, filteredList]
      })
        .reduce((p, [key, list]) => {
          p[key] = list
          return p
        }, {})
    },
    tankLinings() {
      return Array.from(new Set(Object.values(this.fleet)
        // Get all tank linings
        .map(shipList => shipList
            // Get all tank linings
            .map(ship => ship.tanklinings)

            // Flatten the arrays so they become a big list of arrays
            .reduce((p, c) => [...p, ...c], [])

          // Set removes duplicates, filter away any null values
        ).flat())).filter(x => x)
        .sort()
    },
    shipDecades() {
      return Array.from(new Set(Object.values(this.fleet)
        // Get all tank linings
        .map(shipList => shipList
            // Get all tank linings
            .map(ship => ship.decade)

            // Flatten the arrays so they become a big list of arrays
            .reduce((p, c) => [...p, c], [])

          // Set removes duplicates, filter away any null values
        ).flat())).filter(x => x)
        .sort()
    },
    totalCount() {
      return Object.values(this.filteredFleet).reduce((p, c) => p + c.length, 0)
    }
  }
}
</script>

<style>

</style>

